import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";

const Footer = ({ t }) => {
  const location = useLocation();

  // Kiolvassuk az első szegmenst az URL-ből (pl. "en", "hu", "de")
  const lang = location.pathname.split("/")[1];

  return (
    <footer className="footer bg-light mt-4 py-4">
      <div className="container-fluid">
        {/* 1. sor: Név + social ikonok */}
        <div className="row align-items-center my-4">
          <div className="col-md-6 text-md-start text-center ps-4 mb-2 mb-md-0">
            <h5 className="mb-0 fw-bold footer-Brand">AI Inside Life</h5>
          </div>
          <div className="col-md-6 text-md-end text-center">
            <ul className="list-inline mb-0">
              <li className="list-inline-item mx-2 social-media">
                <a href="https://www.facebook.com/profile.php?id=61581990698080" target="_blank" rel="noreferrer">
                  <span className="fa fa-facebook"></span>
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href="https://twitter.com/LifeAi73125" target="_blank" rel="noreferrer">
                  <span className=" fa fa-twitter"></span>
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a
                  href="https://www.instagram.com/aiinsidelife/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="fa fa-instagram"></span>
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href="https://www.youtube.com/@AiInsideLife" target="_blank" rel="noreferrer">
                  <span className="fa fa-youtube"></span>
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href="mailto:info@aiinsidelife.com?subject=My%20Message&body=You%20are%20invited%20to%20a%20big%20summer%20party!">
                  <span className="fa fa-envelope"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* 2. sor: Navigációs linkek */}
        <div className="row mb-3">
          <div className="col text-center">
            <div className="footer-links">
              {/*<NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/NewsArchive`}
              >
                {t("archive")}
              </NavLink>*/}

              <NavLink
                className="mx-2 text-decoration-none"
                to="/PrivacyPolicy"
              >
                {t("policy")}
              </NavLink>

              <NavLink
                className="mx-2 text-decoration-none"
                //to={`/${lang}/TermsOfUse`}
                to="/TermsOfUse"
              >
                {t("terms")}
              </NavLink>

              <NavLink
                className="mx-2 text-decoration-none"
                //to={`/${lang}/cookies`}
                to="/CookiePolicy"
              >
                {t("cookie")}
              </NavLink>

              <NavLink
                className="mx-2 text-decoration-none"
                //to={`/${lang}/impressum`}
                to="/Imprint"
              >
                {t("imprint")}
              </NavLink>

              {/*<NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/media`}
              >
                {t("media")}
              </NavLink>*/}

              <NavLink
                className="mx-2 text-decoration-none"
                to={`/${lang}/Contact`}
              >
                {t("contact")}
              </NavLink>
            </div>
          </div>
        </div>

        {/* 3. sor: Copyright */}
        <div className="row">
          <div className="col text-center">
            <p className="footer-copyright mb-0">
              © 2024 AI Inside Life. {t("copyright")}.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default withTranslation()(Footer);
